import React, { useEffect, useState, useMemo } from 'react'
import api from '../components/api';
import { dataTableRender, rotulo, rotuloEnviado, sleep, cor, corEnviado, corCertificado } from '../components/functions'
import { useHistory } from 'react-router-dom'
//import { MDBDataTableV5 } from 'mdbreact';
import LoaderIcon from "react-loader-icon";
import ModalEnergia from '../modals/energia'
import ModalEmailCorrecao from '../modals/emailCorrecao'

import ModalAmbiente from '../components/Energia_DadosProducao_Abas/modals/Ambiente'
import ModalAmbienteResumo from '../components/Energia_DadosProducao_Abas/modals/AmbienteResumo'

import ModalEnergiaEletricaResumo from '../components/Energia_DadosProducao_Abas/modals/EnergiaEletricaResumo'
import ModalEnergiaEletricaComprada from '../components/Energia_DadosProducao_Abas/modals/EnergiaEletricaComprada'
import ModalEnergiaEletricaGerada from '../components/Energia_DadosProducao_Abas/modals/EnergiaEletricaGerada'
import ModalEnergiaCombustivel from '../components/Energia_DadosProducao_Abas/modals/Combustivel'
import ModalEnergiaIluminacao from '../components/Energia_DadosProducao_Abas/modals/Iluminacao'
import ModalEnergiaHVACUnitario from '../components/Energia_DadosProducao_Abas/modals/HVACUnitario'
import ModalEnergiaHVACIndireta from '../components/Energia_DadosProducao_Abas/modals/HVACIndireta'
import ModalEnergiaHVACDireta from '../components/Energia_DadosProducao_Abas/modals/HVACDireta'

import ModalEnergiaIluminacaoResumo from '../components/Energia_DadosProducao_Abas/modals/EnergiaIluminacaoResumo'
import ModalEnergiaCombustivelResumo from '../components/Energia_DadosProducao_Abas/modals/EnergiaCombustivelResumo'


import ModalValidacao from '../modals/validacao'

import { useVerificaDesafioContext } from '../context/verificaDesafioContext'

import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';


import ModalEmailVer from '../modals/emailVer'
import { useEmailVerContext } from '../context/emailVerContext'


import "@fortawesome/fontawesome-free/css/all.min.css";
import Badge from 'react-bootstrap/Badge';
import Pendencias from '../components/Pendencias'


const Energia = () => {

    const history = useHistory()

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    const { desafioEmail_id, setDesafioEmail_id } = useEmailVerContext()

    const [carregando, setCarregando] = useState('block')

    var [energia_id, setEnergia_id] = useState()
    var [resultado, setResultado] = useState([])

    var [resultadoRede, setResultadoRede] = useState()
    var [resultadoPend, setResultadoPend] = useState([])

    var [adesao_institucional_id, setAdesaoInstitucionalId] = useState()

    var [ano, setAno] = useState(new Date().getFullYear() -1)
    var [anoProps, setAnoProps] = useState()
    var [anos, setAnos] = useState()
    var [adesao_institucional_id_ref, setAdesaoInstitucionalIdRef] = useState(0)

    var [resultadoCorrecoes, setResultadoCorrecoes] = useState([])
    var [totalCorrecoes, setTotalCorrecoes] = useState(0)
    var [totalPreenchimentos, setTotalPreenchimentos] = useState(0)

    const [totalAdesoes, setTotalAdesoes] = useState(0)

    const [uf, setUF] = useState('')
    const [resultadoUF, setResultadoUF] = useState([])
    const [regiao, setRegiao] = useState('')
    const [resultadoRegiao, setResultadoRegiao] = useState([])

    const [totalVerificados, setTotalVerificados] = useState(0)
    const [resultadoVerificados, setResultadoVerificados] = useState([])
    const [totalNotificacoes, setTotalNotificacoes] = useState(0)

    //secaoConsumo, secaoEficiencia, secaoPlanilha


    /*

    <table id="dataTableExample3" className="table table-bordered table-striped table-hover">
        <thead>
            <tr>
                <th>Nome Fantasia</th>
                <th>CNPJ</th>
                <th><center>Último ano</center></th>
                
                <th><center>Data último preenchimento</center></th>
                <th><center>Adesão em</center></th>
                <th><center>Upload da planilha mais recente</center></th>
                
            </tr>
        </thead>
        <tbody>
            {resultado}
        </tbody>
        
    </table>

    */

    const columnsVerificados = useMemo(
      () => [
        {
          accessorKey: 'nome_fantasia', //access nested data with dot notation
          header: 'Nome Fantasia',
        },
        {
          accessorKey: 'cnpj',
          header: 'CNPJ',
        },
        {
          accessorKey: 'anoDesafio',
          header: 'Ano',
        },

        {
          accessorKey: 'certificacao',
          header: 'Reconhecimento',
          Cell: ({ renderedCellValue, row }) => (
          
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: corCertificado(renderedCellValue) }}>{renderedCellValue}</Badge>
         
          ),
        },
       

      ],
      [],
    );


    const columnsR = useMemo(
      () => [
        {
          accessorKey: 'nome_fantasia', //access nested data with dot notation
          header: 'Nome Fantasia',
        },
        {
          accessorKey: 'cnpj',
          header: 'CNPJ',
        },
        {
          accessorKey: 'ultimoAnoInformado',
          header: 'Último ano',
        },
        {
          accessorKey: 'dataUltimoPreenchimento',
          header: 'Data último preenchimento',
        },
        {
          accessorKey: 'dataAdesao',
          header: 'Adesão em',
        },
        
       

      ],
      [],
    );




    const columns = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },
          {
            accessorKey: 'uf_codigo',
            header: 'UF',
          },

          {
            accessorKey: 'situacaoPerfilAnual',
            header: 'Perfil Anual',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },

          {
            accessorKey: 'dataAdesao',
            header: 'Adesão',
          },


          {
            accessorKey: 'secaoEficiencia',
            header: 'Gestão Eficiência Energética',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  
          {
            accessorKey: 'secaoEnergiaEletrica',
            header: 'Energia Elétrica',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  
          {
            accessorKey: 'secaoCombustiveis',
            header: 'Combustíveis',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  
          {
            accessorKey: 'secaoAmbientes',
            header: 'Ambientes',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  
          {
            accessorKey: 'secaoIluminacao',
            header: 'Iluminação',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  
          {
            accessorKey: 'secaoHVAC',
            header: 'HVAC',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  
          {
            accessorKey: 'secaoRefrigeracao',
            header: 'Refrigeração',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  
          {
            accessorKey: 'secaoAquecimento',
            header: 'Aquecimento',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  
          {
            accessorKey: 'secaoGeradores',
            header: 'Geradores Estacionários',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  
          {
            accessorKey: 'secaoSADT',
            header: 'SADT',
            Cell: ({ renderedCellValue, row }) => (
              
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
              <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
         
            ),
          },
  


          {
            accessorKey: 'dataUltimoPreenchimento',
            header: 'Último preenchimento',
          },

          {
            accessorKey: 'dataAdesao',
            header: 'Adesão',
          },

          {
            accessorKey: 'situacaoEnviado',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : renderedCellValue == null || renderedCellValue == 'P' ? 'primary' : 'warning' }`}>{rotuloEnviado(renderedCellValue)}</span>
              //<Badge style={{  backgroundColor: renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>
              <Badge style={{  backgroundColor: corEnviado(renderedCellValue) }}>{rotuloEnviado(renderedCellValue)}</Badge>
           
            ),
          },


          {
            accessorKey: 'dataEnvio',
            header: 'Enviado em',
          },


          {
            accessorKey: 'dataHoraUltimaAuditoria',
            header: 'Última auditoria em',
          },
         


         
         

        ],
        [],
      );




    const columnsCorrecoes = useMemo(
      () => [
        {
          accessorKey: 'nome_fantasia', //access nested data with dot notation
          header: 'Nome Fantasia',
        },
        {
          accessorKey: 'cnpj',
          header: 'CNPJ',
        },
        {
          accessorKey: 'anoDesafio',
          header: 'Ano',
        },

        {
          accessorKey: 'situacaoPerfilAnual',
          header: 'Perfil Anual',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoEficiencia',
          header: 'Gestão Eficiência Energética',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoEnergiaEletrica',
          header: 'Energia Elétrica',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoCombustiveis',
          header: 'Combustíveis',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoAmbientes',
          header: 'Ambientes',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoIluminacao',
          header: 'Iluminação',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoHVAC',
          header: 'HVAC',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoRefrigeracao',
          header: 'Refrigeração',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoAquecimento',
          header: 'Aquecimento',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoGeradores',
          header: 'Geradores Estacionários',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)} {renderedCellValue}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'secaoSADT',
          header: 'SADT',
          Cell: ({ renderedCellValue, row }) => (
            
            //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
            <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
       
          ),
        },

        {
          accessorKey: 'situacaoEnviado',
          header: 'Situação',
          Cell: ({ renderedCellValue, row }) => (
          
              //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : renderedCellValue == 'P' ? 'danger' : 'primary' }`}>{rotuloEnviado(renderedCellValue)}</span>
              //<Badge style={{  backgroundColor: renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>
              //<Badge style={{  backgroundColor: renderedCellValue == 'Z' ? '#c769c7' : renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>
              <Badge style={{  backgroundColor: corEnviado(renderedCellValue) }}>{rotuloEnviado(renderedCellValue)}</Badge>
              
              
         
          ),
        },



       
       

      ],
      [],
    );



      /*

    const data = {
        columns: [

          
          
          {
            label: 'Nome Fantasia',
            field: 'nome_fantasia',
            sort: 'asc',
            width: 270
          },
          {
            label: 'CNPJ',
            field: 'cnpj',
            sort: 'asc',
            width: 200
          },
          {
            label: 'Ano',
            field: 'anoDesafio',
            sort: 'asc',
            width: 100
          },
          
          {
            label: 'Perfil Anual',
            field: 'situacaoPerfilAnual',
            sort: 'asc',
            width: 100
          },

          {
            label: 'Dados de Consumo e Equipamentos',
            field: 'secaoConsumo',
            sort: 'asc',
            width: 100
          },

          {
            label: 'Dados de Iniciativas de Ef. Energética',
            field: 'secaoEficiencia',
            sort: 'asc',
            width: 100
          },

          {
            label: 'Envio da planilha de dados',
            field: 'secaoPlanilha',
            sort: 'asc',
            width: 100
          },


          {
            label: 'Dados Energia',
            field: 'secaoEnergia',
            sort: 'asc',
            width: 100
          },

          

          {
            label: 'Situação',
            field: 'situacaoEnviado',
            sort: 'asc',
            width: 100
          },
          
          {
            label: 'Enviado em',
            field: 'dataEnvio',
            sort: 'asc',
            width: 100
          },

        ],

        rows: resultadoPend
    }

    */

    async function carregaRede() {

        await api.get(`adesaoInstitucionalRede`).then((result) => {

            setResultadoRede(result.data.map((rs) =>

                <option value={rs.adesao_institucional_id} key={rs.adesao_institucional_id}>{rs.razao_social}</option>
            
            ))

        })

    }


    /*
    async function geraExcel() {

        

        window.toastr.success('Aguarde, gerando XLSX...')

        await api.get('geraExcelEnergia/0').then((result) => {

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.open(`http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`)
                    //window.location.href = `http://172.16.1.253:3600/${result.data.arquivo}`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`

                })

                
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }
    */


    const geraExcel = async () => {

      window.toastr.info("Aguarde...");

      try {

      const response = await api.get(`geraExcelEnergia/0`, {
          responseType: "blob",
          validateStatus: (status) => true // para não cair direto no catch
      });

      if (response.status !== 200) {
          // ler como texto para ver o erro real
          const errorText = await response.data.text();
          console.error("Erro backend:", errorText);
          window.toastr.error("Erro ao exportar: " + errorText);
          return;
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "energia.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      window.toastr.success("Download concluído!");
      } catch (err) {
      console.error(err);
      window.toastr.error("Falha ao baixar arquivo");
      }
  };




    /*
    async function geraExcelPend() {

        window.toastr.success('Aguarde, gerando XLSX...')
        

        await api.get(`geraExcelEnergiaPend/${adesao_institucional_id_ref}/${ano}`).then((result) => {

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.location.href = `http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`

                })
                
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }
    */


    const geraExcelPend = async () => {

        window.toastr.info("Aguarde...");

        try {

        const response = await api.get(`geraExcelEnergiaPend/${adesao_institucional_id_ref}/${ano}`, {
            responseType: "blob",
            validateStatus: (status) => true // para não cair direto no catch
        });

        if (response.status !== 200) {
            // ler como texto para ver o erro real
            const errorText = await response.data.text();
            console.error("Erro backend:", errorText);
            window.toastr.error("Erro ao exportar: " + errorText);
            return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "energia.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        window.toastr.success("Download concluído!");
        } catch (err) {
        console.error(err);
        window.toastr.error("Falha ao baixar arquivo");
        }
    };


    async function desafioEnergiaLista() {

        await api.get('energiaLista').then((result) => {
            //console.log(result.data)

            setTotalAdesoes(result.data.length)
            setResultado(result.data)

            /*
            setResultado(result.data.map((rs) => 

                <tr style={{ cursor: 'pointer'}} onClick={() => history.push(`DesafioEnergia/${rs.adesao_institucional_id}`)}>
                    <td>
                        {rs.nome_fantasia}
                    </td>
                    <td>
                        {rs.cnpj}
                    </td>
                    <td>
                        <center>{rs.ultimoAnoInformado}</center>
                    </td>
                    
                    <td>
                        <center>{rs.dataUltimoPreenchimento}</center>
                    </td>
                    <td>
                        <center>{rs.dataAdesao}</center>
                    </td>
                    <td>
                        <center>{rs.planilhaMaisRecente}</center>
                    </td>
                </tr>

            ))

            dataTableRender('dataTableExample3', 0, 'asc')
            */



        }).catch((err) => {
            console.log(err.response)
        })

    }


    async function carregaAnos() {

        var anoTemp = []

        var anoAtual = new Date().getFullYear()

        for (var x = anoAtual; x >= 2008; x--) {

            var anoJson = {

                ano: x,

            }

            anoTemp.push(anoJson)

        }

        setAnos(anoTemp.map((rs) =>
        
            <option value={rs.ano}>{rs.ano}</option>
        
        ))

    }



    async function preenchimentos(adesao_institucional_id_ref) {

        if (adesao_institucional_id_ref == null) { adesao_institucional_id_ref = 0 }



        var dataPost = {

          regiao: regiao,
          uf: uf,

      }

      setCarregando('block')

        await api.post(`/energiaListaPendencias/${adesao_institucional_id_ref}/${ano}`, dataPost).then((result) => {

            //console.log(result.data)

            setTotalPreenchimentos(result.data.length)
            setResultadoPend(result.data)

            /*
            setResultadoPend(result.data.map((rs) => {

                return {

                    nome_fantasia: rs.nome_fantasia,
                    cnpj: rs.cnpj,
                    situacaoPerfilAnual: rotulo(rs.situacaoPerfilAnual),
                    secaoConsumo: rotulo(rs.secaoConsumo),
                    secaoEficiencia: rotulo(rs.secaoEficiencia),
                    secaoPlanilha: rotulo(rs.secaoPlanilha),
                    secaoEnergia: rs.secaoEnergia == 'I' || rs.secaoEnergia == 'C' ? 'Sim' : 'Não',
                    dataEnvio: rs.dataEnvio,
                    situacaoEnviado: rotuloEnviado(rs.situacaoEnviado),
                    dataEnvio: rs.dataEnvio,
                    dataUltimoPreenchimento: rs.dataUltimoPreenchimento,
                    anoDesafio: rs.anoDesafio,
                    energia_id: rs.energia_id,
                    adesao_institucional_id: rs.adesao_institucional_id,
                    clickEvent: () => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio); setAdesaoInstitucionalId(rs.adesao_institucional_id); setEnergia_id(rs.energia_id); window.$("#modalEnergia").modal('show');}
                    
                }

            }))
            */

            setCarregando('none')

        }).catch((err) => {

            console.log(err)
            setCarregando('none')

        })


    }




    const correcoes = () => {

      var dataPost = {

          desafio: 'Energia'

      }

      api.post('desafioValidaCorrecoes', dataPost).then((result) => {

          setResultadoCorrecoes(result.data)
          setTotalCorrecoes(result.data.length)

      }).catch((err) => {

          console.log(err.response)

      })


  }



  const carregaRegiao = () => {

    api.get('regiao').then((result) => {

        setResultadoRegiao(result.data.map((rs) =>
                
            <option value={rs.regiao}>{rs.regiao}</option>
    
        ))

    }).catch((err) => {

        console.log(err.response)

    })

}


const carregaUF = () => {

    api.get('uf').then((result) => {

        //console.log(result.data)

        setResultadoUF(result.data.map((rs) =>
                
            <option value={rs.uf_codigo}>{rs.uf_codigo}</option>
    
        ))

    }).catch((err) => {

        console.log(err.response)

    })

}



const verificados = () => {

  var dataPost = {

      desafio: 'Energia'

  }

  api.post('desafioValidaVerificados', dataPost).then((result) => {

      //console.log(result.data, 'verificados')

      setResultadoVerificados(result.data)
      setTotalVerificados(result.data.length)

  }).catch((err) => {

      console.log(err.response)

  })


}


const abreCertificado = async (dataPost) => {

        

  api.post('certificado', dataPost).then((result) => {

      window.toastr.info('Aguarde...')
      
      if (result.data.arquivo) {

          sleep(1000).then(() => {

            window.open(`${process.env.REACT_APP_API}/pdf/${result.data.arquivo}`)

          })

      }

  }).catch((err) => {

      console.log(err.response)

  })

}


    useEffect(() => {

        carregaRegiao()
        carregaUF()
        carregaRede()
        carregaAnos()
        desafioEnergiaLista()
        

    }, [])

    useEffect(() => {

        //console.log(ano)
        
        preenchimentos(adesao_institucional_id_ref)
        correcoes()
        verificados()

    }, [ano, uf, regiao, verificaDesafio])


    return (

        <div>
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-gleam'></i>
                </div>
                <div class='header-title'>
                    <h1>Desafio Energia</h1>
                    <small>Administração</small>
                    
                </div>
            </div>


            <ul className="nav nav-tabs">
                <li ><a href="#tab1" data-toggle="tab">Adesões ({totalAdesoes})</a></li>
                <li className="active"><a href="#tab2" data-toggle="tab" onClick={() => {} } >Preenchimentos ({totalPreenchimentos})</a></li>
                <li ><a href="#tab3" data-toggle="tab" onClick={() => {} } >Correções ({totalCorrecoes})</a></li>
                <li ><a href="#tab4" data-toggle="tab" onClick={() => {} } >Verificados ({totalVerificados})</a></li>
                <li ><a href="#tab5" data-toggle="tab" onClick={() => {} } >Notificações ({totalNotificacoes})</a></li>
                
                
            </ul>

            <div class="tab-content">
                <div class="tab-pane fade in " id="tab1">
                    <div class="panel-body">


                        <div class="col-md-12">

                            <button type="button" class="btn btn-success" onClick={() => geraExcel()}>Exportar XLS</button>&nbsp;

                            <br/><br/>

                        </div>

                        <div class="col-md-12">

                            <div className="table-responsive">
                                

                                <MaterialReactTable 

                                    columns={columnsR} 
                                    data={resultado} 
                                    localization={MRT_Localization_PT_BR}
                                    //rowsPerPage={20}
                                    //options={options}
                                    initialState={{ density: 'compact' }}
                                    muiTableHeadCellProps={{
                                        //easier way to create media queries, no useMediaQuery hook needed.
                                        sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                        },
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                            fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                            },
                                        },
                                    }}
                                    muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        //console.info(event, row.original.usuario_id);
                                        history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                        //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                        //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setHospClima_id(row.original.hospClima_id); window.$("#modalDesafioClima").modal('show')

                                    },
                                    sx: {
                                        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                    })}
                                  />

                            </div>
                        </div>

                    </div>

                </div>
            
                <div className="tab-pane fade in active" id="tab2">
                    <div class="panel-body">


                    <div class="col-md-12">


                        <button type="button" class="btn btn-success" onClick={() => geraExcelPend()}>Exportar XLS</button>&nbsp;
                        <br/>


                    </div>

                    <div className="col-md-12">

                    <div className="form-group">

                            <br/>
                            
                            <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {preenchimentos(event.target.value);setAdesaoInstitucionalIdRef(event.target.value)}} value={adesao_institucional_id_ref} >
                                <option value="0">[Rede ou Sistema de Saúde]</option>
                                {resultadoRede}
                            </select>  
                            
                        </div>

                        </div>

                        <div className="col-md-4">
                              <div className="form-group">

                                  
                                  
                                  <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setAno(event.target.value)}} value={ano} >
                                      <option value={0}>Todos os anos</option>
                                      {anos}
                                  </select>  
                                  
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">

                                  
                                  <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setUF(event.target.value)}} value={uf} >
                                      <option value="">[UF]</option>
                                      {resultadoUF}
                                  </select>  
                                  
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">

                                  
                                  <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setRegiao(event.target.value)}} value={regiao} >
                                      <option value="">[Região]</option>
                                      {resultadoRegiao}
                                  </select>  
                                  
                              </div>
                          </div>

                          <div className="col-md-12" style={{ display: carregando }} >
                          <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                          </div>

                          <div className="col-md-12" style={{ display: carregando == 'none' ? 'block' : 'none'}}>



                                <MaterialReactTable 

                                columns={columns} 
                                data={resultadoPend} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ density: 'compact' }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    //console.info(event, row.original.usuario_id);
                                    //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                    //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                    //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                    setAnoProps(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setEnergia_id(row.original.energia_id); window.$("#modalEnergia").modal('show')

                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}
                                />

                            </div>



                    </div>

                </div>
                <div className="tab-pane fade in" id="tab5">

                    <Pendencias
                        desafio="Energia"
                        setTotalNotificacoes={setTotalNotificacoes}
                        abrirModal={(item) => {

                            setAdesaoInstitucionalId(
                                item.adesao_institucional_id
                            )

                            setEnergia_id(
                                item.energia_id ??
                                item.formulario_id
                            )

                            setAnoProps(
                                item.anoPerfil ??
                                item.anoDesafio ??
                                item.ano
                            )

                            window.$(
                                '#modalEnergia'
                            ).modal('show')

                        }}
                    />

                </div>
                <div className="tab-pane fade in" id="tab4">

                            <div className="panel-body">

                                <div className="col-md-12" style={{ display: carregando }} >
                                  <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                                </div>
                            
                              <div className="col-md-12" style={{ display: resultadoVerificados ? 'block' : 'none'}}>


                                    <MaterialReactTable 

                                        columns={columnsVerificados} 
                                        data={resultadoVerificados} 
                                        localization={MRT_Localization_PT_BR}
                                        //rowsPerPage={20}
                                        //options={options}
                                        initialState={{ density: 'compact' }}
                                        muiTableHeadCellProps={{
                                            //easier way to create media queries, no useMediaQuery hook needed.
                                            sx: {
                                            fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                            },
                                            },
                                        }}
                                        muiTableBodyCellProps={{
                                            sx: {
                                                fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                                },
                                            },
                                        }}
                                        muiTableBodyRowProps={({ row }) => ({
                                        onClick: (event) => {
                                            
                                            //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); 
                                            //setHospClima_id(row.original.hospClima_id); window.$("#modalCertificado").modal('show')

                                            abreCertificado({

                                                ano: row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio,
                                                adesao_institucional_id: row.original.adesao_institucional_id,
                                                formulario_id: row.original.residuo_id,
                                                certificacao: row.original.certificacao,
                                                origem: 'Energia',

                                            })

                                        },
                                        sx: {
                                            cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                        },
                                        })}

                                    />


                                </div>

                            </div>

                        </div>
                <div className="tab-pane fade in" id="tab3">


                      <div className="col-md-12" style={{ display: carregando }} >
                          <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                      </div>
                  
                    <div className="col-md-12" style={{ display: resultadoCorrecoes ? 'block' : 'none'}}>


                      <MaterialReactTable 

                      columns={columnsCorrecoes} 
                      data={resultadoCorrecoes} 
                      localization={MRT_Localization_PT_BR}
                      //rowsPerPage={20}
                      //options={options}
                      initialState={{ density: 'compact' }}
                      muiTableHeadCellProps={{
                          //easier way to create media queries, no useMediaQuery hook needed.
                          sx: {
                          fontSize: {
                              xs: '8px',
                              sm: '9px',
                              md: '10px',
                              lg: '11px',
                              xl: '12px',
                          },
                          },
                      }}
                      muiTableBodyCellProps={{
                          sx: {
                              fontSize: {
                              xs: '8px',
                              sm: '9px',
                              md: '10px',
                              lg: '11px',
                              xl: '12px',
                              },
                          },
                      }}
                      muiTableBodyRowProps={({ row }) => ({
                      onClick: (event) => {
                          //console.info(event, row.original.usuario_id);
                          //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                          //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                          //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                          //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                          setAnoProps(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setEnergia_id(row.original.energia_id); window.$("#modalEnergia").modal('show')
                      },
                      sx: {
                          cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                      },
                      })}
                      />

                  </div>


                </div>
            
        </div>


            


        <ModalEnergia adesao_institucional_id={adesao_institucional_id} ano={ano} />
        

        <ModalAmbiente />
        <ModalAmbienteResumo  energia_id={energia_id} />


        <ModalEnergiaEletricaComprada />
        <ModalEnergiaEletricaGerada />
        <ModalEnergiaEletricaResumo  energia_id={energia_id} />

        <ModalEnergiaCombustivel />
        <ModalEnergiaCombustivelResumo energia_id={energia_id} />

        <ModalEnergiaIluminacao />
        <ModalEnergiaIluminacaoResumo energia_id={energia_id} />

        <ModalEnergiaHVACUnitario energia_id={energia_id} />

        <ModalEnergiaHVACIndireta />
        <ModalEnergiaHVACDireta />
        
        <ModalValidacao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={energia_id} origem='Energia' correcoes={correcoes} />
        <ModalEmailCorrecao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={energia_id} origem='Energia' correcoes={correcoes} />
        <ModalEmailVer desafioEmail_id={desafioEmail_id}  />

        </div>

    )

}

export default Energia